import React, { useEffect, useRef, useState } from 'react'
import EditMasterDetails from '../../../components/companyUser/profile/editCRMUserMasterDetailsComponent';
import EditWorkDetails from '../../../components/companyUser/profile/editCRMUserWorkDetailsComponent';
import EditBasicDetails from '../../../components/companyUser/profile/editCRMUserBasicDetailsComponent';
import EditStatutoryDetails from '../../../components/companyUser/profile/editCRMUserStatutoryDetails';
import { ToastContainer, toast } from 'react-toastify';

const Preview = (props) => {
    const [mode, setMode] = useState('edit');
    const [selectedTab, setSelectedTab] = useState('profile')

    useEffect(() => {

    }, [])



    return (
        <React.Fragment>
            <ToastContainer />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="profile-foreground position-relative mx-n4 mt-n4 customProfileLoginBG">
                            <div className="profile-wid-bg">
                            </div>
                        </div>


                        <div className="pt-4 mb-4 mb-lg-3 pb-lg-4 profile-wrapper">
                            <div className="row g-4">
                                <div className="col-auto">
                                    <div className="avatar-lg">
                                        <div className="avatar-container">
                                            <img
                                                src={"/assets/images/users/user-dummy-img.jpg"}
                                                className="img-thumbnail rounded-circle"
                                            />
                                            <label htmlFor="profile_pic" className="ri-edit-2-line edit-icon customProfileEditIcon" ></label>
                                            <input
                                                type="file"
                                                id="profile_pic"
                                                style={{ display: 'none' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="pt-4">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div>
                                    <div className="d-flex profile-wrapper profileLoginNavButtons">
                                        <ul
                                            className="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                                            role="tablist"
                                        >
                                            <li className="nav-item" role="presentation">
                                                <a
                                                    className={`nav-link fs-14 ${selectedTab === 'profile' ? 'active' : ''}`}
                                                    href="javascript:void(0)"
                                                    onClick={() => { setSelectedTab('profile') }}
                                                >
                                                    <i className="ri-airplay-fill d-inline-block d-md-none" />
                                                    <span className="d-none d-md-inline-block">Profile Details</span>
                                                </a>
                                            </li>


                                        </ul>
                                        {mode === 'preview' ? <a
                                            href="pages-profile-settings.html"
                                            className="btn editProfileButton"
                                        >
                                            <i className="ri-edit-box-line align-bottom" /> Edit Profile
                                        </a>:<a
                                            href="pages-profile-settings.html"
                                            className="btn editProfileButton"
                                        >
                                            <i className="ri-edit-box-line align-bottom" /> Preview Profile
                                        </a>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </React.Fragment>
    )
}

export default Preview


// import React, { useEffect, useState } from 'react'
// import MasterDetails from '../../../components/companyUser/profile/masterDetails';
// import { v3_my_profile } from '../../../actions/v3/profile';

// const Preview = () => {
//     const [selectedTab, setSelectedTab] = useState('master')
//     const [mode, setMode] = useState('preview');
//     const [masterDetails, setMasterDetails] = useState(null);
//     useEffect(() => {
//         v3_my_profile().then((res) => {
//             if (res.status) {
//                 setMasterDetails(res.result.master_detail);
//             }
//         })
//     }, [])
//     return (
//         <React.Fragment>
//             <div className="main-content">
//                 <div className="page-content">
//                     <div className="container-fluid">
//                         <div className="profile-foreground position-relative mx-n4 mt-n4">
//                             <div className="profile-wid-bg">
//                                 {/* <img
//                                     src="/assets/images/profile-bg.jpg"
//                                     alt=""
//                                     className="profile-wid-img"
//                                 /> */}
//                             </div>
//                         </div>
//                         <div className="pt-4 mb-4 mb-lg-3 pb-lg-4 profile-wrapper">
//                             <div className="row g-4">
//                                 <div className="col-auto">
//                                     <div className="avatar-lg">
//                                         <img
//                                             src="/assets/images/users/avatar-1.jpg"
//                                             alt="user-img"
//                                             className="img-thumbnail rounded-circle"
//                                         />
//                                     </div>
//                                 </div>
//                                 {/*end col*/}
//                                 <div className="col">
//                                     <div className="p-2">
//                                         <h3 className="text-white mb-1">{masterDetails?.FULL_NAME}</h3>
//                                         <p className="text-white text-opacity-75">Owner &amp; Founder</p>
//                                         {/* <div className="hstack text-white-50 gap-1">
//                                             <div className="me-2">
//                                                 <i className="ri-map-pin-user-line me-1 text-white text-opacity-75 fs-16 align-middle" />
//                                                 California, United States
//                                             </div>
//                                             <div>
//                                                 <i className="ri-building-line me-1 text-white text-opacity-75 fs-16 align-middle" />
//                                                 Themesbrand
//                                             </div>
//                                         </div> */}
//                                     </div>
//                                 </div>
//                             </div>
//                             {/*end row*/}
//                         </div>
//                         <div className="row">
//                             <div className="col-lg-12">
//                                 <div>
//                                     <div className="d-flex profile-wrapper">
//                                         {/* Nav tabs */}
//                                         <ul
//                                             className="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
//                                             role="tablist"
//                                         >
//                                             <li className="nav-item" role="presentation">
//                                                 <a
//                                                     className={`nav-link fs-14 ${selectedTab === 'master' ? 'active' : ''}`}
//                                                     href="javascript:void(0)"
//                                                     onClick={() => { setSelectedTab('master') }}
//                                                 >
//                                                     <i className="ri-airplay-fill d-inline-block d-md-none" />
//                                                     <span className="d-none d-md-inline-block">Master</span>
//                                                 </a>
//                                             </li>
//                                             <li className="nav-item" role="presentation">
//                                                 <a
//                                                     className={`nav-link fs-14 ${selectedTab === 'work' ? 'active' : ''}`}

//                                                     href="javascript:void(0)"
//                                                     onClick={() => { setSelectedTab('work') }}

//                                                 >
//                                                     <i className="ri-list-unordered d-inline-block d-md-none" />{" "}
//                                                     <span className="d-none d-md-inline-block">Work</span>
//                                                 </a>
//                                             </li>
//                                             <li className="nav-item" role="presentation">
//                                                 <a
//                                                     className={`nav-link fs-14 ${selectedTab === 'basic' ? 'active' : ''}`}

//                                                     href="javascript:void(0)"
//                                                     onClick={() => { setSelectedTab('basic') }}

//                                                 >
//                                                     <i className="ri-price-tag-line d-inline-block d-md-none" />{" "}
//                                                     <span className="d-none d-md-inline-block">Basic</span>
//                                                 </a>
//                                             </li>
//                                             <li className="nav-item" role="presentation">
//                                                 <a
//                                                     className={`nav-link fs-14 ${selectedTab === 'statutory' ? 'active' : ''}`}

//                                                     href="javascript:void(0)"
//                                                     onClick={() => { setSelectedTab('statutory') }}

//                                                 >
//                                                     <i className="ri-folder-4-line d-inline-block d-md-none" />{" "}
//                                                     <span className="d-none d-md-inline-block">Statutory</span>
//                                                 </a>
//                                             </li>
//                                         </ul>
//                                         <div className="flex-shrink-0">
//                                             <a
//                                                 href="pages-profile-settings.html"
//                                                 className="btn btn-success"
//                                             >
//                                                 <i className="ri-edit-box-line align-bottom" /> Edit Profile
//                                             </a>
//                                         </div>
//                                     </div>
//                                     {mode === 'preview' && selectedTab === 'master' && masterDetails && <MasterDetails
//                                         data={masterDetails}
//                                     />}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//             </div>

//         </React.Fragment>
//     )
// }

// export default Preview